import Vue from 'vue';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import { faAngleRight } from '@fortawesome/pro-solid-svg-icons/faAngleRight';
import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons/faArrowLeft';
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons/faArrowRight';
import { faArrowAltCircleRight } from '@fortawesome/pro-solid-svg-icons/faArrowAltCircleRight';
import { faBars } from '@fortawesome/pro-solid-svg-icons/faBars';
import { faBell } from '@fortawesome/pro-solid-svg-icons/faBell';
import { faBookSpells } from '@fortawesome/pro-solid-svg-icons/faBookSpells';
import { faCertificate } from '@fortawesome/pro-solid-svg-icons/faCertificate';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle';
import { faCircle } from '@fortawesome/pro-solid-svg-icons/faCircle';
import { faCode } from '@fortawesome/pro-solid-svg-icons/faCode';
import { faCog } from '@fortawesome/pro-solid-svg-icons/faCog';
import { faCogs } from '@fortawesome/pro-solid-svg-icons/faCogs';
import { faComment } from '@fortawesome/pro-solid-svg-icons/faComment';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons/faCaretDown';
import { faCaretUp } from '@fortawesome/pro-solid-svg-icons/faCaretUp';
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons/faChevronDown';
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons/faChevronRight';
import { faChevronUp } from '@fortawesome/pro-solid-svg-icons/faChevronUp';
import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons/faChevronLeft';
import { faDownload } from '@fortawesome/pro-solid-svg-icons/faDownload';
import { faHeart } from '@fortawesome/pro-solid-svg-icons/faHeart';
import { faExclamation } from '@fortawesome/pro-solid-svg-icons/faExclamation';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons/faExclamationCircle';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle';
import { faFilter } from '@fortawesome/pro-solid-svg-icons/faFilter';
import { faInfo } from '@fortawesome/pro-solid-svg-icons/faInfo';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';
import { faLightbulb } from '@fortawesome/pro-solid-svg-icons/faLightbulb';
import { faLink } from '@fortawesome/pro-solid-svg-icons/faLink';
import { faMinusCircle } from '@fortawesome/pro-solid-svg-icons/faMinusCircle';
import { faPlusCircle } from '@fortawesome/pro-solid-svg-icons/faPlusCircle';
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus';
import { faPuzzlePiece } from '@fortawesome/pro-solid-svg-icons/faPuzzlePiece';
import { faSeedling } from '@fortawesome/pro-solid-svg-icons/faSeedling';
import { faSignOutAlt } from '@fortawesome/pro-solid-svg-icons/faSignOutAlt';
import { faStar } from '@fortawesome/pro-solid-svg-icons/faStar';
import { faStarHalfAlt } from '@fortawesome/pro-solid-svg-icons/faStarHalfAlt';
import { faStarOfLife } from '@fortawesome/pro-solid-svg-icons/faStarOfLife';
import { faSearch } from '@fortawesome/pro-solid-svg-icons/faSearch';
import { faSpinner } from '@fortawesome/pro-solid-svg-icons/faSpinner';
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes';
import { faTimesCircle } from '@fortawesome/pro-solid-svg-icons/faTimesCircle';
import { faTrophy } from '@fortawesome/pro-solid-svg-icons/faTrophy';
import { faUser } from '@fortawesome/pro-solid-svg-icons/faUser';
import { faUsers } from '@fortawesome/pro-solid-svg-icons/faUsers';
import { faUserSecret } from '@fortawesome/pro-solid-svg-icons/faUserSecret';
import { faEnvelope } from '@fortawesome/pro-solid-svg-icons/faEnvelope';
import { faShareAlt } from '@fortawesome/pro-solid-svg-icons/faShareAlt';
import { faSortAmountDown } from '@fortawesome/pro-solid-svg-icons/faSortAmountDown';

import { faArrowLeft as faArrowLeftLight } from '@fortawesome/pro-light-svg-icons/faArrowLeft';
import { faCog as faCogLight } from '@fortawesome/pro-light-svg-icons/faCog';
import { faMinusCircle as faMinusCircleLight } from '@fortawesome/pro-light-svg-icons/faMinusCircle';
import { faPlusCircle as faPlusCircleLight } from '@fortawesome/pro-light-svg-icons/faPlusCircle';
import { faSearch as faSearchLight } from '@fortawesome/pro-light-svg-icons/faSearch';
import { faTimes as faTimesLight } from '@fortawesome/pro-light-svg-icons/faTimes';
import { faEnvelope as faEnvelopeLight } from '@fortawesome/pro-light-svg-icons/faEnvelope';
import { faCheeseSwiss as faCheeseSwissLight } from '@fortawesome/pro-light-svg-icons/faCheeseSwiss';
import { faSteak as faSteakLight } from '@fortawesome/pro-light-svg-icons/faSteak';
import { faBreadSlice as faBreadSliceLight } from '@fortawesome/pro-light-svg-icons/faBreadSlice';
import { faCookieBite as faCookieBiteLight } from '@fortawesome/pro-light-svg-icons/faCookieBite';
import { faPie as faPieLight } from '@fortawesome/pro-light-svg-icons/faPie';
import { faLeaf as faLeafLight } from '@fortawesome/pro-light-svg-icons/faLeaf';
import { faStar as faStarLight } from '@fortawesome/pro-light-svg-icons/faStar';
import { faComment as faCommentLight } from '@fortawesome/pro-light-svg-icons/faComment';
import { faSeedling as faSeedlingLight } from '@fortawesome/pro-light-svg-icons/faSeedling';
import { faTachometerAltAverage as faTachometerAltAverageLight } from '@fortawesome/pro-light-svg-icons/faTachometerAltAverage';
import { faLaughBeam as faLaughBeamLight } from '@fortawesome/pro-light-svg-icons/faLaughBeam';
import { faExclamationCircle as faExclamationCircleLight } from '@fortawesome/pro-light-svg-icons/faExclamationCircle';
import { faCow as faCowLight } from '@fortawesome/pro-light-svg-icons/faCow';
import { faPig as faPigLight } from '@fortawesome/pro-light-svg-icons/faPig';
import { faTurkey as faTurkeyLight } from '@fortawesome/pro-light-svg-icons/faTurkey';
import { faFish as faFishLight } from '@fortawesome/pro-light-svg-icons/faFish';
import { faGlass as faGlassLight } from '@fortawesome/pro-light-svg-icons/faGlass';
import { faCogs as faCogsLight } from '@fortawesome/pro-light-svg-icons/faCogs';
import { faHeart as faHeartLight } from '@fortawesome/pro-light-svg-icons/faHeart';
import { faSignOutAlt as faSignOutAltLight } from '@fortawesome/pro-light-svg-icons/faSignOutAlt';
import { faHandPointUp as faHandPointUpLight } from '@fortawesome/pro-light-svg-icons/faHandPointUp';
import { faTreeChristmas as faTreeChristmasLight } from '@fortawesome/pro-light-svg-icons/faTreeChristmas';
import { faStore as faStoreLight } from '@fortawesome/pro-light-svg-icons/faStore';

import { faFlag as faFlagRegular } from '@fortawesome/pro-regular-svg-icons/faFlag';
import { faCog as faCogRegular } from '@fortawesome/pro-regular-svg-icons/faCog';
import { faHeart as faHeartRegular } from '@fortawesome/pro-regular-svg-icons/faHeart';
import { faSeedling as faSeedlingRegular } from '@fortawesome/pro-regular-svg-icons/faSeedling';
import { faStar as faStarRegular } from '@fortawesome/pro-regular-svg-icons/faStar';
import { faThumbsUp as faThumbsUpRegular } from '@fortawesome/pro-regular-svg-icons/faThumbsUp';
import { faTreeChristmas as faTreeChristmasRegular } from '@fortawesome/pro-regular-svg-icons/faTreeChristmas';
import { faExternalLink as faExternalLinkRegular } from '@fortawesome/pro-regular-svg-icons/faExternalLink';
import { faUser as faUserRegular } from '@fortawesome/pro-regular-svg-icons/faUser';
import { faListAlt as faListAltRegular } from '@fortawesome/pro-regular-svg-icons/faListAlt';

import { faPinterest } from '@fortawesome/free-brands-svg-icons/faPinterest';
import { faFacebookSquare } from '@fortawesome/free-brands-svg-icons/faFacebookSquare';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';

library.add(
    faAngleRight,
    faArrowLeftLight,
    faArrowLeft,
    faArrowRight,
    faArrowAltCircleRight,
    faBars,
    faBell,
    faBookSpells,
    faCertificate,
    faCode,
    faCog,
    faCogLight,
    faCogRegular,
    faCogs,
    faComment,
    faCaretDown,
    faCaretUp,
    faChevronDown,
    faChevronRight,
    faChevronUp,
    faChevronLeft,
    faCheck,
    faCheckCircle,
    faCircle,
    faDownload,
    faEnvelopeLight,
    faExclamation,
    faExclamationCircle,
    faExclamationTriangle,
    faExternalLinkRegular,
    faFilter,
    faFlagRegular,
    faHeartRegular,
    faInfo,
    faInfoCircle,
    faLightbulb,
    faLink,
    faListAltRegular,
    faMinusCircle,
    faPlusCircle,
    faPlus,
    faMinusCircleLight,
    faPlusCircleLight,
    faPuzzlePiece,
    faSeedling,
    faSignOutAlt,
    faStarOfLife,
    faStarRegular,
    faSpinner,
    faSearch,
    faSearchLight,
    faTimes,
    faTimesCircle,
    faTimesLight,
    faTreeChristmasRegular,
    faTrophy,
    faUser,
    faUsers,
    faUserSecret,
    faEnvelope,
    faCheeseSwissLight,
    faSteakLight,
    faBreadSliceLight,
    faCookieBiteLight,
    faPieLight,
    faLeafLight,
    faShareAlt,
    faSortAmountDown,
    faStarLight,
    faStar,
    faStarHalfAlt,
    faTachometerAltAverageLight,
    faCommentLight,
    faSeedlingLight,
    faSeedlingRegular,
    faLaughBeamLight,
    faExclamationCircleLight,
    faCowLight,
    faPigLight,
    faTurkeyLight,
    faFishLight,
    faGlassLight,
    faCogsLight,
    faHeartLight,
    faHeart,
    faSignOutAltLight,
    faHandPointUpLight,
    faFacebookSquare,
    faPinterest,
    faInstagram,
    faTreeChristmasLight,
    faStoreLight,
    faTwitter,
    faThumbsUpRegular,
    faUserRegular,
);

Vue.component('font-awesome-icon', FontAwesomeIcon);
